module.exports = __webpack_public_path__ + "img/icon_sports_skiing.dbb5a56f.png";